import React from 'react';
export function ProblemSection() {
  return <section className="w-full bg-black py-16 px-4 pt-[0px] pb-[0px]" data-id="element-268">
      <div className="max-w-3xl mx-auto text-center" data-id="element-269">
        <h2 className="text-2xl sm:text-3xl font-bold text-white mb-10" data-id="element-270">
          Si sos profe de batería en Argentina,
          <br data-id="element-271" />
          <span className="text-[#FFD700]" data-id="element-272">esto te va a sonar familiar:</span>
        </h2>

        <div className="space-y-4 text-left mb-12" data-id="element-273">
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-274">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-275">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-276">
              Domingo a la noche buscando ejercicios en YouTube que nunca quedan
              bien ni están ordenados por nivel
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-277">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-278">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-279">
              Llegás al lunes con algo que "más o menos sirve" y durante la
              clase te das cuenta que le falta estructura, progresión y cierre
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-280">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-281">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-282">
              Tus evaluaciones son siempre las mismas o siempre inventadas
              porque no tenés un sistema de medición de progreso con rúbricas
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-283">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-284">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-285">
              Cuando el tema es difícil —independencia, técnica Moeller,
              compases irregulares— no sabés cómo explicarlo sin perder al
              alumno en el camino
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-286">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-287">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-288">
              Tenés alumnos de distintos niveles y no tenés material
              diferenciado: el principiante se aburre y el avanzado se frustra
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-289">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-290">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-291">
              No podés justificar un aumento de precio porque no tenés un
              sistema visible que lo respalde
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-292">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-293">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-294">
              Trabajás dando clases todo el día, llegás al fin de semana agotado
              y el domingo volvés a empezar el ciclo
            </p>
          </div>
        </div>

        <p className="text-[#FFD700] text-2xl sm:text-3xl font-black mb-8" data-id="element-295">
          ¿Cuántos domingos más vas a perder haciendo lo mismo?
        </p>

        {/* Gold divider */}
        <div className="h-px bg-gradient-to-r from-transparent via-[#FFD700] to-transparent w-full" data-id="element-296" />
      </div>
    </section>;
}